<template>
  <div class="shop-info-container">
    <div class="header">ショップ情報</div>
    <div class="information">
      <div class="float-left">
        <img :src="logo" alt="..." class="img-thumbnail logo" />
      </div>
      <div class="float-left shop-content">
        <router-link
          :to="`/customer/shop/${product.owner}`"
          class="shop-name"
          style="font-size: 1rem; display: block"
        >
          <span v-line-clamp="1">{{ product.shopName }}</span>
        </router-link>
        <div style="width: 150px; display: flex;">
          <star-rating
            :rating="reviewAvg"
            :star-size="18"
            :show-rating="false"
            :read-only="true"
            :increment="0.1"
          />
          <span class="text-bold average-rate--count ml-5">{{ reviewAvg ? reviewAvg.toFixed(2) : 0 }}</span>
        </div>
        <div>{{ topUser }}%の高評価</div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertToFloat } from '@/utils/commonUtil';
import StarRating from 'vue-star-rating';

export default {
  components: {
    StarRating
  },
  props: {
    shop: {
      type: Object,
      default: () => ({
        name: '',
        numOfReview: 1,
        totalPointReview: 0,
        image: [],
        description: []
      })
    },
    product: {
      type: Object,
      default: () => ({
        shopName: ''
      })
    },
    shopReviews: {
      type: Object,
      default: () => ({
        oneStar: 0,
        twoStar: 0,
        threeStar: 0,
        fourStar: 0,
        fiveStar: 0
      })
    }
  },
  computed: {
    reviewAvg: function() {
      if (!this.shop.numOfReview) {
        return 0;
      }
      return convertToFloat(this.shop.totalPointReview / this.shop.numOfReview, 2);
    },
    logo: function() {
      if (!this.shop.image || this.shop.image.length < 1) {
        return require('@/assets/images/shop_default.svg');
      }

      return this.shop.image[0];
    },
    topUser: function() {
      const sumValues = obj => Object.values(obj).reduce((a, b) => a + b);
      var totalReviews = sumValues(this.shopReviews);
      var goodReviews = this.shopReviews.fourStar + this.shopReviews.fiveStar;
      var percent;
      if (totalReviews > 0) {
        percent = (100 * goodReviews) / totalReviews;
      } else {
        percent = 0;
      }

      return Math.round(percent * 100) / 100;
    }
  }
};
</script>

<style scoped>
.logo {
  width: 64px;
  height: 64px;
}

.float-left {
  float: left;
  margin-left: 10px;
}

.header {
  margin-left: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  margin-top: 16px;
}

.shop-info-container {
  float: right;
  width: 240px;
  padding-bottom: 16px;
  background-color: #f7f7f7;
}

.shop-name {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  margin-bottom: 6px;
  letter-spacing: normal;
}

.shop-content {
  width: 60%;
}
</style>
